<span *ngIf="src && src !== ''">
    <img [src]="src" alt='' [style.width.px]="width" [style.height]="height > 0 ? height + 'px' : 'auto'" />
</span>
